import './header.scss';
import { burger } from './utils/burger';
import { megamenu } from './utils/megamenu';
import { scroll } from './utils/scroll';
import { submenu } from './utils/submenu';
import logo from './utils/logo';

burger();
megamenu();
scroll();
submenu();
logo();
